import { render, staticRenderFns } from "./VoucherCenter.vue?vue&type=template&id=5bf09a3a&scoped=true&"
import script from "./VoucherCenter.vue?vue&type=script&lang=js&"
export * from "./VoucherCenter.vue?vue&type=script&lang=js&"
import style0 from "./VoucherCenter.vue?vue&type=style&index=0&id=5bf09a3a&scoped=true&lang=css&"
import style1 from "./VoucherCenter.vue?vue&type=style&index=1&id=5bf09a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf09a3a",
  null
  
)

export default component.exports